module.exports = __webpack_public_path__ + "img/project12_1.jpg.d102a555.webp";